export default __webpack_public_path__ + "static/media/4.2f2d2d7b.jpg";